<table class="table table-striped usage-reports"
       *ngIf="usageReports">
    <thead>
        <tr>
            <th>Year</th>
            <th>Month</th>
            <th>Council</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let usageReport of usageReports">
            <tr>
                <td>{{ usageReport.year }}</td>
                <td>{{ usageReport.month }}</td>
                <td><button (click)="downloadReport(usageReport)">{{ usageReport.name }}</button></td>
            </tr>
        </ng-container>
    </tbody>
</table>
